import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { $api } from "../generated/client";

export const useUpdateCurrentUser = () => {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();

  return $api.useMutation("patch", "/users/me", {
    onSuccess() {
      successNotification();
    },
    onError() {
      errorNotification();
    },
  });
};
